<template>
  <v-form ref="form" >

    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      <!-- <v-col cols="12">
        <v-autocomplete
          v-model="entry.groundId"
          label="Área"
          :items="extraData.accountContext.allGrounds"
          item-value="id"
          item-text="name"
          readonly
        />
      </v-col> -->

      <v-col cols="12">
        <v-text-field
          v-model="entry.stateInscription"
          v-bind="getObject('stateInscription')"
          label="Inscrição Estadual"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import DateField from "@shared_components/date_field.vue"
import gql from 'graphql-tag'
import BaseUtil from "@shared_components/base_util.vue";

export default {
  data() {
    return {
      entryAttributes: {},
      citiesListLoading: false,
      citiesList: [],
      stateId: null,
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    DateField: DateField,
    MaskedTextField: MaskedTextField,
    BaseUtil: BaseUtil,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);

    if (this.extraData.userContext.currentUser) {
      // this.entry.groundId = this.extraData.userContext.currentUser.groundId;
      this.entry.personId = this.extraData.userContext.currentUser.id;
      // this.entry.ground = this.extraData.userContext.currentUser.ground;
    }
  },
  mounted() {
  },
  computed: {
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },
  }
};
</script>

<style scoped></style>
